export default "__VITE_ASSET__b681c839__"